<template>
  <div class="home">
    <div class="util-snippet">
      <div
        itemscope
        itemtype="https://schema.org/Organization"
      >
        <span itemprop="name">Spalopia, S.L.</span>

        <div
          itemprop="address"
          itemscope
          itemtype="https://schema.org/PostalAddress"
        >
          <span itemprop="streetAddress">Avenida Sor Soledad Cobian, 3, 38300 - Orotava, La</span>
          <span itemprop="addressLocality">Canarias, España</span>
          <span itemprop="email">ayuda@spalopia.com</span>
        </div>
      </div>

      <div
        itemscope
        itemtype="https://schema.org/WebSite"
      >
        <link
          itemprop="url"
          :href="domain"
        >
      </div>
    </div>

    <div>
      <BenefitsCard
        class="only-desktop-block"
        :tags="['GIVINGS', 'BEST_PRICE', 'SAFE_PAYMENT']"
        :can-close="false"
        :is-title-displayed="false"
      />
    </div>

    <div class="home__container">
      <div class="only-mobile home__main-title">
        <Lang by-key="home-header-title" />
      </div>
    </div>

    <!-- isBlackFriday -->
    <div
      v-if="isChristmas"
      class="home__container__small"
    >
      <Card
        class="home__highlight-display christmas-bg"
        mobile-with-border
        desktop-with-border
      >
        <div class="home__highlight-display__side-texts">
          <p class="title">
            ESTÁ A CHEGAR O NATAL!
          </p>

          <p class="subtitle">
            Já sabe o que vai oferecer este ano tão especial ao seu parceiro, amigos e familiares?
          </p>

          <div>
            <p>
              Fizemos uma seleção muito especial para garantir o presente perfeito!
            </p>
          </div>

          <div class="base-price">
            <span>
              Ofereça Bem-Estar a partir de
            </span>
            <span class="base-price__price">20 €</span>
          </div>

          <div class="button">
            <SplNuxtLink
              is-external
              :to="promoChristmasLink"
              no-lang
            >
              <SplButton
                variant="acent"
                size="full"
              >
                VER TODAS AS OPÇÕES
              </SplButton>
            </SplNuxtLink>
          </div>
        </div>

        <div>
          <Card
            class="home__highlight-display__side-details"
            mobile-with-border
            desktop-with-border
          >
            <div class="image">
              <img src="~/assets/images/home/promos/christmas-promo.webp">
            </div>

            <p class="title">
              Este ano, ofereça Vales-presente da Spalopia e desfrute dos sorrisos de quem os recebe
            </p>

            <div class="subtitle">
              Mais de 200 promoções para escolher!
            </div>

            <div class="base-price">
              <span>
                <Lang by-key="from-value" />
              </span>
              <span class="base-price__price">20 €</span>
            </div>
          </Card>
        </div>
      </Card>
    </div>

    <!-- isValentines -->
    <div
      v-else-if="isValentines"
      class="home__container__small"
    >
      <HomePromoValentines />
    </div>

    <!-- isFathersDay -->
    <div
      v-else-if="isFathersDay"
      class="home__container__small"
    >
      <HomePromoFathersDay />
    </div>

    <!-- isMothersDay -->
    <div
      v-else-if="isMothersDay"
      class="home__container__small"
    >
      <HomePromoMothersDay />
    </div>

    <div
      v-else-if="isHolyWeek"
      class="home__container__small"
    >
      <HomePromoHolyWeek />
    </div>

    <div
      v-else-if="isTeacherGift"
      class="home__container__small"
    >
      <HomePromoTeacherGift />
    </div>

    <div
      v-else
      class="home__container__small"
    >
      <!-- <HomePromoDayPass /> -->
      <HomePromoSprunch />
    </div>

    <div class="home__container">
      <BenefitsCard
        class="only-mobile"
        :tags="['GIVINGS-SMALL', 'BEST_PRICE', 'SAFE_PAYMENT']"
        :can-close="false"
        :is-title-displayed="false"
      />
    </div>

    <div class="home__container home__header-and-text">
      <div>
        <h2><Lang by-key="home-promo-section-1-title" /></h2>

        <p>
          <Lang by-key="home-promo-section-1-text" />
        </p>
      </div>
    </div>

    <div class="home__container">
      <div class="home__list-display-5">
        <div
          v-for="promo in promoLinksA"
          :key="promo.url"
          class="home__list-display-5__item"
        >
          <SplNuxtLink
            :to="promo.url"
            is-external
          >
            <div class="home__promo-item">
              <div>
                <div v-if="promo.imageKey">
                  <HomeImage :variant="promo.imageKey" />
                </div>

                <h3 class="home__promo-item__title">
                  {{ promo.title }}
                </h3>
              </div>

              <div class="home__promo-item__description">
                {{ promo.description }}
              </div>

              <SplButton
                variant="acent"
                size="full"
              >
                <Lang
                  by-key="see-more"
                  capitalize-first
                />
              </SplButton>
            </div>
          </SplNuxtLink>
        </div>
      </div>
    </div>

    <div class="home__container home__header-and-text">
      <div>
        <h2><Lang by-key="home-promo-section-2-title" /></h2>

        <p>
          <Lang by-key="home-promo-section-2-text" />
        </p>
      </div>
    </div>

    <div class="home__container">
      <div class="home__list-display-5">
        <div
          v-for="treatment in treatmentListA"
          :key="treatment.url"
          class="home__list-display-5__item"
        >
          <SplNuxtLink
            :to="treatment.url"
            is-external
          >
            <div class="home__promo-item">
              <div>
                <div v-if="treatment.imageKey">
                  <HomeImage :variant="treatment.imageKey" />
                </div>

                <h3 class="home__promo-item__title">
                  {{ treatment.title }}
                </h3>
              </div>

              <div class="home__promo-item__description">
                {{ treatment.description }}
              </div>

              <SplButton
                variant="acent"
                size="full"
              >
                <Lang
                  by-key="see-more"
                  capitalize-first
                />
              </SplButton>
            </div>
          </SplNuxtLink>
        </div>
      </div>
    </div>

    <div class="home__container home__header-and-text">
      <div>
        <h2><Lang by-key="home-promo-section-3-title" /></h2>

        <p>
          <Lang by-key="home-promo-section-3-text" />
        </p>
      </div>
    </div>

    <div class="home__container">
      <div class="home__list-display-5">
        <div
          v-for="promo in promoLinksB"
          :key="promo.url"
          class="home__list-display-5__item"
        >
          <SplNuxtLink
            :to="promo.url"
            is-external
          >
            <div class="home__promo-item">
              <div>
                <div v-if="promo.imageKey">
                  <HomeImage :variant="promo.imageKey" />
                </div>

                <h3 class="home__promo-item__title">
                  {{ promo.title }}
                </h3>
              </div>

              <div class="home__promo-item__description">
                {{ promo.description }}
              </div>

              <SplButton
                variant="acent"
                size="full"
              >
                <Lang
                  by-key="see-more"
                  capitalize-first
                />
              </SplButton>
            </div>
          </SplNuxtLink>
        </div>
      </div>
    </div>

    <div class="only-desktop-block">
      <Separator hide />
      <BenefitsCard
        :tags="['VALID_BONUSES', 'SUPPORT', 'GIVE_EXPERIENCIES']"
        :can-close="false"
        :is-title-displayed="false"
      />
      <Separator hide />
    </div>

    <div class="home__container home__header-and-text">
      <div>
        <h2><Lang by-key="home-promo-section-4-title" /></h2>

        <p>
          <Lang by-key="home-promo-section-4-text" />
        </p>
      </div>
    </div>

    <div
      v-if="shouldDisplayESLocs"
      class="home__container"
    >
      <div class="home__location-title">
        España
      </div>

      <div class="home__list-display-4">
        <div
          v-for="location in esLocationLinks"
          :key="location.url"
          class="home__list-display-4__item"
        >
          <SplNuxtLink
            :to="location.url"
            is-external
          >
            <div class="home__location-item">
              <div class="home__location-item__image-wrapper">
                <HomeImage :variant="location.imageKey" />
              </div>

              <SplButton
                variant="acent"
                size="full"
              >
                {{ location.title }}
              </SplButton>
            </div>
          </SplNuxtLink>
        </div>
      </div>
    </div>

    <div
      v-if="shouldDisplayPTLocs"
      class="home__container"
    >
      <div class="home__location-title">
        Portugal
      </div>

      <div class="home__list-display-4">
        <div
          v-for="location in ptLocationLinks"
          :key="location.url"
          class="home__list-display-4__item"
        >
          <SplNuxtLink
            :to="location.url"
            is-external
          >
            <div class="home__location-item">
              <div class="home__location-item__image-wrapper">
                <HomeImage :variant="location.imageKey" />
              </div>

              <SplButton
                variant="acent"
                size="full"
              >
                {{ location.title }}
              </SplButton>
            </div>
          </SplNuxtLink>
        </div>
      </div>
    </div>

    <div class="home__container home__header-and-text">
      <div>
        <h2><Lang by-key="home-promo-hotel-trust-header-title" /></h2>

        <p>
          <Lang by-key="home-promo-hotel-trust-header-description" />
        </p>
      </div>
    </div>

    <div class="home__container home__hotel-trust-images">
      <img
        src="/images/home/hotel-trust/AR-hotels-logo-300x210.png"
        alt="AR Hotels"
      >
      <img
        src="/images/home/hotel-trust/castilla-termal-hotels-logo-300x210.png"
        alt="Castilla Termal Hotels"
      >
      <img
        src="/images/home/hotel-trust/catalonia-hotels-logo-300x210.png"
        alt="Catalonia Hotels"
      >
      <img
        src="/images/home/hotel-trust/Eurostar-Hotels-300x210.png"
        alt="Eurostar Hotels"
      >
      <img
        src="/images/home/hotel-trust/hipotels-hotels-logo-300x210.png"
        alt="Hipotels Hotels"
      >
      <img
        src="/images/home/hotel-trust/iberostar-logo-300x210.jpg"
        alt="Iberostar"
      >
      <img
        src="/images/home/hotel-trust/logo-hospes-hoteles-300x210.png"
        alt="Hospes Hoteles"
      >
      <img
        src="/images/home/hotel-trust/logo-lopesan-300x210.jpg"
        alt="Lopesan"
      >
      <img
        src="/images/home/hotel-trust/jupiter-hotel-group.png"
        alt="Jupiter Gotel Group"
      >
      <img
        src="/images/home/hotel-trust/logo-relais-300x210.jpg"
        alt="Relais"
      >
      <img
        src="/images/home/hotel-trust/logo-vincci-hoteles-300x210.png"
        alt="Vincci Hoteles"
      >
      <img
        src="/images/home/hotel-trust/senator-logo-300x210.png"
        alt="Senator"
      >
      <img
        src="/images/home/hotel-trust/piamonte-hotels.png"
        alt="Piamonte Hotels"
      >
    </div>

    <Separator hide />

    <div class="home__highlight">
      <div class="home__container">
        <GiftCardMini />
      </div>
    </div>

    <Separator hide />
    <div
      v-if="isDev"
      class="home__container__small"
    >
      <NewsLetterSub />
    </div>
  </div>
</template>

<script lang="ts">
import BenefitsCard from '~/core/components/spa/BenefitsCard.vue'
import GiftCardMini from '~/core/components/shared/GiftCardMini.vue'
import NewsLetterSub from '~/core/components/home/NewsLetterSub.vue'

import Separator from '~/core/components/shared/Separator.vue'
import Card from '~/core/components/shared/Card.vue'
import Badge from '~/core/components/shared/Badge.vue'
import SplNuxtLink from '~/core/components/shared/SplNuxtLink.vue'
import SplButton from '~/core/components/shared/form/SplButton.vue'
import SlideShow from '~/core/components/shared/gallery/SlideShow.vue'

import HomeImage from '~/core/components/home/HomeImage.vue'
import HomePromoDayPass from '~/core/components/home/HomePromoDayPass.vue'
import HomePromoSprunch from '~/core/components/home/HomePromoSprunch.vue'
import HomePromoValentines from '~/core/components/home/HomePromoValentines.vue'
import HomePromoFathersDay from '~/core/components/home/HomePromoFathersDay.vue'
import HomePromoMothersDay from '~/core/components/home/HomePromoMothersDay.vue'
import HomePromoHolyWeek from '~/core/components/home/HomePromoHolyWeek.vue'
import HomePromoTeacherGift from '~/core/components/home/HomePromoTeacherGift.vue'

import { getHomeMetadata } from '~/core/composable/home/useHomePageHeader'
import { useSessionLocation } from '~/core/composable/shared/useSessionLocation'
import { useLocatedLinks } from '~/core/composable/shared/useLocatedLinks'

import config from '~/core/ts/server-config'

definePageMeta({
  layout: 'home',
})

type PromoEntry = {
  title: string,
  imageKey?: any,
  description?: string,
  url: string,
}

export default defineNuxtComponent({
  components: {
    BenefitsCard,
    GiftCardMini,
    NewsLetterSub,
    Separator,
    Card,
    Badge,
    SplNuxtLink,
    SplButton,
    SlideShow,
    HomeImage,
    HomePromoDayPass,
    HomePromoSprunch,
    HomePromoValentines,
    HomePromoFathersDay,
    HomePromoMothersDay,
    HomePromoHolyWeek,
    HomePromoTeacherGift,
  },
  async setup() {
    const route = useRoute()
    const uri = route.path
    useHead(getHomeMetadata(uri))

    const runtimeConfig = useRuntimeConfig()

    const domain = runtimeConfig.public.domain

    const isDev = runtimeConfig.public.isDev

    const isChristmas = config.promos.isChristmas
    const isBlackFriday = config.promos.isBlackFriday
    const isValentines  = config.promos.isValentines
    const isFathersDay  = config.promos.isFathersDay
    const isMothersDay  = config.promos.isMothersDay
    const isHolyWeek    = config.promos.isHolyWeek
    const isTeacherGift = config.promos.isTeacherGift

    const sessionLocation = useSessionLocation()

    const promoLinksA: Array<PromoEntry> = ([
      {
        title: 'Spa',
        imageKey: 'spa',
        description: 'Relaxamento com circuito termal',
        url: '/promocoes/circuito-termal/',
      },
      {
        title: 'Spa + Gastronomia',
        imageKey: 'spa-gastro',
        description: 'Alimenta o teu espírito',
        url: '/promocoes/circuito-termal-e-almoco/',
      },
      {
        title: 'Spa + Massagem',
        imageKey: 'spa-masaje',
        description: 'Descanso e relaxamento total',
        url: '/promocoes/circuito-de-spa-e-massagem-de-relaxamento/',
      },
      {
        title: 'Day Spa',
        imageKey: 'Daypass',
        description: 'Prazer de dia inteiro',
        url: '/promocoes/daypass-spa/',
      },
      {
        title: 'Spa + Ritual',
        imageKey: 'spa-ritual',
        description: 'Circuito spa e Ritual',
        url: '/promocoes/circuito-e-ritual-termal/',
      }
    ])

    const treatmentListA: Array<PromoEntry> = [
      {
        title: 'Hidroterapia',
        url: '/hidroterapia/',
        imageKey: 'Hidroterapia',
        description: 'Desfrutar de um banho relaxante',
      },
      {
        title: 'Massagens',
        url: '/massagens/',
        imageKey: 'Masajes',
        description: 'Libertar tensões',
      },
      {
        title: 'Faciais',
        url: '/tratamentos-faciais/',
        imageKey: 'Tratamientos-Faciales',
        description: 'Oxigena o rosto',
      },
      {
        title: 'Corporais',
        url: '/tratamentos-corporais/',
        imageKey: 'Tratamientos-Corporales',
        description: 'Dê à sua pele um novo brilho',
      },
      {
        title: 'Rituais',
        url: '/rituais-de-beleza/',
        imageKey: 'Rituales-de-Belleza',
        description: 'Merece desconectar',
      },
    ]

    const promoLinksB: Array<PromoEntry> = ([
      {
        title: 'Spa para casais',
        imageKey: 'spa-pareja',
        description: 'Um momento único a dois',
        url: '/promocoes/spa-para-casais/',
      },
      {
        title: 'Spa para grávidas',
        imageKey: 'spa-embarazada',
        description: 'Aliviar a tensão e o cansaço',
        url: '/promocoes/spas-para-gravidas/',
      },
      {
        title: 'Spa para crianças',
        imageKey: 'spa-kids',
        description: 'Descanso merecido',
        url: '/promocoes/spas-para-criancas/',
      },
      {
        title: 'Spa privado',
        imageKey: 'spa-privado',
        description: 'Paz e harmonia a dois',
        url: '/promocoes/spa-privado/',
      },
      {
        title: 'Massagem para dois',
        imageKey: 'masaje-dos',
        description: 'Relaxe o seu corpo em companhia',
        url: '/promocoes/massagem-para-dois/',
      }
    ])

    const esLocationLinks: Array<PromoEntry> = ([
      {
        url: '/spas/tenerife/',
        imageKey: 'tenerife',
        title: 'Tenerife',
      },

      {
        url: '/spas/gran-canaria/',
        imageKey: 'gran-canaria',
        title: 'Gran Canaria',
      },

      {
        url: '/spas/granada/',
        imageKey: 'granada',
        title: 'Granada',
      },

      {
        url: '/spas/cadiz/',
        imageKey: 'cadiz',
        title: 'Cádiz',
      },

      {
        url: '/spas/mallorca/',
        imageKey: 'mallorca',
        title: 'Mallorca',
      },

      {
        url: '/spas/valencia/',
        imageKey: 'valencia',
        title: 'Valencia',
      },

      {
        url: '/spas/madrid/',
        imageKey: 'madrid',
        title: 'Madrid',
      },

      {
        url: '/spas/barcelona/',
        imageKey: 'barcelona',
        title: 'Barcelona',
      },
    ])

    const ptLocationLinks: Array<PromoEntry> = ([
      {
        url: '/spas/lisboa/',
        imageKey: 'lisboa',
        title: 'Lisboa',
      },

      {
        url: '/spas/oporto/',
        imageKey: 'oporto',
        title: 'Oporto',
      },

      {
        url: '/spas/madeira/',
        imageKey: 'madeira',
        title: 'Madeira',
      },

      {
        url: '/spas/acores/',
        imageKey: 'azores',
        title: 'Açores',
      },
    ])

    const shouldDisplayESLocs = computed(() => {
      const country = sessionLocation.storedLocationCountry.value

      if (!country) {
        return true
      }

      return country.country === 'ES'
    })

    const shouldDisplayPTLocs = computed(() => {
      const country = sessionLocation.storedLocationCountry.value

      if (!country) {
        return true
      }

      return country.country === 'PT'
    })

    const {
      baseSpaLink,
      promoBlackFridayLink,
      promoChristmasLink,
      fetchChristmasPromo
    } = useLocatedLinks()

    await fetchChristmasPromo()

    return {
      domain,

      isDev,

      isChristmas,
      isValentines,
      isFathersDay,
      isMothersDay,
      isHolyWeek,
      isTeacherGift,

      promoBlackFridayLink,
      promoChristmasLink,

      baseSpaLink,

      promoLinksA,
      treatmentListA,
      promoLinksB,

      shouldDisplayESLocs,
      shouldDisplayPTLocs,

      esLocationLinks,
      ptLocationLinks,
    }
  },
})
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  @apply opacity-100;
  @apply transition-all duration-500;
}
.fade-enter,
.fade-leave-to {
  @apply opacity-0;
  @apply mt-4;
}

@import url('./home.scss');
</style>
